var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandShake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 35,
    height: 35,
    rx: 10,
    fill: "#FFF595"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8342 17.0681V23.1865H30.3929V13.909H22.3551L19.1959 10.7498C18.1962 9.75007 16.5566 9.75007 15.5169 10.7498L12.1178 14.1489C11.398 14.8687 11.398 16.0684 12.1178 16.7882C12.8376 17.508 14.0373 17.508 14.7571 16.7882L16.8366 14.7087L22.1951 20.0673C23.1949 21.067 22.9149 22.7466 21.6753 23.3864L14.3972 25.8258C13.2375 26.2257 11.9579 25.9057 11.0781 25.066L7.31911 21.307H4V12.0295H8.55878V18.1478",
    stroke: "#FFF595",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2756 23.506L18.2764 20.4668",
    stroke: "#D3FF9A",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5157 24.4668L15.3965 21.3477",
    stroke: "#D3FF9A",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5568 25.4659L12.5176 22.3867",
    stroke: "#D3FF9A",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandShake);
export default __webpack_public_path__ + "static/media/hand-shake.74d7a9cce6923755e674b2df46571e0f.svg";
export { ForwardRef as ReactComponent };